module.exports = fox._r("images/fs_on.gif", __webpack_public_path__ + "images/fs_on.gif");


//////////////////
// WEBPACK FOOTER
// ./images/fs_on.gif
// module id = 1048
// module chunks = 4